function ConfirmDialog({
  open,
  title = "Are you sure?",
  message = "",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  loading = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onCancel?.();
    }
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="confirm-title" onClick={handleOverlayClick}>
      <div className="confirm-modal">
        <div className="confirm-content">
          <div className="confirm-pill">Heads up</div>
          <h3 id="confirm-title" className="confirm-title">
            {title}
          </h3>
          {message ? <p className="confirm-message">{message}</p> : null}
        </div>
        <div className="confirm-actions">
          <button className="ghost-btn" type="button" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button className="primary-btn" type="button" onClick={onConfirm} disabled={loading}>
            {loading ? "Removing..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
